import { call, put, takeEvery } from 'redux-saga/effects';
import { businessEntityActionCreators, BusinessEntityActionKeys, SaveAddress } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { addressActionCreators } from '../../address';
import { prospectActionCreators } from '../../prospects';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../businessEntityApi';
import { IAddressUpdateResponse, IBusinessEntityAddress } from '../businessEntityInterfaces';

function* saveAddressSaga(action: SaveAddress) {
  yield put(uiActionCreators.showSpinnerDialog());
  let result: IEntityWithMessages<IAddressUpdateResponse>;
  // tslint:disable-next-line:prefer-conditional-expression
  if (action.payload.address.addressId > 0) {
    result = yield call(api.UpdateAddress, action.payload);
  } else {
    result = yield call(api.AddAddress, action.payload);
  }

  if (!result.error && result.value) {
    yield put(addressActionCreators.setAddresses(result.value.addresses));
    yield put(
      businessEntityActionCreators.setAddresses(
        result.value.addresses.map<IBusinessEntityAddress>(x => ({
          address: x,
          businessEntityId: action.payload.businessEntityId
        }))
      )
    );
    yield put(prospectActionCreators.setProspects(result.value.prospects));
  }

  yield processMessages(
    result,
    `The following validation problems need to be fixed to save this address:`,
    'There was a problem saving this address.  Please rety.'
  );

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSaveAddress() {
  yield takeEvery(BusinessEntityActionKeys.SAVE_BUSINESS_ENTITY_ADDRESS, saveAddressSaga);
}
